/* =========================================================
   Kort-vælgeren — kerne (ren logik: ingen DOM, intet netværk).
   Bruges af mtw-samling.js i browseren (window.MTWCCore) og af
   tests/kort-vaelger-core.test.cjs i Node.
   ========================================================= */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MTWCCore = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /* ---------- tekst ---------- */
  // Titler fra kataloget indeholder usynlige skilletegn (U+2063 m.fl.), som ødelægger sammenligning.
  function clean(s) { return String(s == null ? '' : s).replace(/[\u2063\u200B\u200C\u200D\uFEFF\u2060]/g, '').trim(); }
  // Opslag på tekster udefra (katalog, kurv, gemt binder) må aldrig ramme Object.prototype ("constructor", "__proto__").
  function dict(src) { return Object.assign(Object.create(null), src); }
  function has(map, key) { return Object.prototype.hasOwnProperty.call(map, key); }
  function isMap(x) { return !!x && typeof x === 'object' && !Array.isArray(x); }
  function qtyIn(map, id) { var n = has(map, id) ? Math.floor(map[id]) : 0; return n > 0 && isFinite(n) ? n : 0; }

  /* ---------- stand ---------- */
  // Cardmarkets skala, som butikkens stand-guide: bedst først.
  var STANDS = ['Near Mint', 'Excellent', 'Good', 'Light Played', 'Played', 'Poor'];
  var LIMITS = [
    { key: 'NM', max: 0, label: 'NM', name: 'Near Mint' },
    { key: 'EX', max: 1, label: 'EX+', name: 'Excellent eller bedre' },
    { key: 'GD', max: 2, label: 'GD+', name: 'Good eller bedre' },
    { key: 'LP', max: 3, label: 'LP+', name: 'Light Played eller bedre' },
    { key: 'PL', max: 4, label: 'PL+', name: 'Played eller bedre' },
    { key: 'ALL', max: 5, label: 'Alle', name: 'Alle stande' }
  ];
  var COND = dict({ 'mint': { rank: 0, name: 'Mint', abbr: 'NM' } });
  ['NM', 'EX', 'GD', 'LP', 'PL', 'PO'].forEach(function (a, i) { COND[STANDS[i].toLowerCase()] = { rank: i, name: STANDS[i], abbr: a }; });
  function known(cond) { return COND[clean(cond).toLowerCase()] || null; }
  // Uden for skalaen (fx "Damaged") = dårligere end Poor.
  function rank(cond) { var k = known(cond); return k ? k.rank : STANDS.length; }
  function limitOf(key) { for (var i = 0; i < LIMITS.length; i++) if (LIMITS[i].key === key) return LIMITS[i]; return LIMITS[0]; }
  // Tager en variant eller en stand-tekst. Uden Condition-option (gradede kort) har varianten ingen stand
  // og er inden for alle grænser; en stand uden for skalaen er kun inden for "Alle".
  function within(v, limitKey) {
    var lim = limitOf(limitKey);
    if (lim.key === 'ALL') return true;
    if (v && typeof v === 'object') { if (v.hasCond === false) return true; v = v.cond; }
    return rank(v) <= lim.max;
  }
  function abbr(v) {
    if (v && typeof v === 'object') { if (v.hasCond === false) return ''; v = v.cond; }
    var c = clean(v), k = known(c);
    if (k) return k.abbr;
    return /^default title$/i.test(c) ? '' : c.slice(0, 2).toUpperCase();
  }

  /* ---------- produkt -> udgaver ---------- */
  var MAX_QTY = 4;
  function optIdx(names, want) { for (var i = 0; i < names.length; i++) if (String(names[i] || '').toLowerCase() === want) return i; return -1; }
  // Rå mtwjson-produkt -> ens form. qty er lagerantal (højst 4); mangler feltet (gammel skabelon i cache), er det 1/0.
  // Uden gyldig pris over 0 er varianten ikke til salg.
  function normalize(raw) {
    var names = (raw.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var ci = optIdx(names, 'condition'), ei = optIdx(names, 'edition'), li = optIdx(names, 'language');
    var pimg = raw.images && raw.images[0] ? (raw.images[0].src || raw.images[0]) : null;
    var variants = (raw.variants || []).map(function (v) {
      var o = [v.option1, v.option2, v.option3];
      var given = o.filter(function (x) { return x != null && x !== ''; });
      var price = Math.round(parseFloat(v.price) * 100) / 100;
      var forSale = !!v.available && isFinite(price) && price > 0;
      var qty = forSale ? Math.max(0, Math.min(MAX_QTY, Math.floor(typeof v.qty === 'number' ? v.qty : 1) || 0)) : 0;
      var k = ci > -1 ? known(o[ci]) : null;
      var vimg = v.featured_image ? (v.featured_image.src || v.featured_image.url || null) : null;
      return {
        id: v.id,
        price: isFinite(price) && price > 0 ? price : 0,
        available: qty > 0,
        qty: qty,
        cond: ci > -1 ? (k ? k.name : clean(o[ci])) : clean(given[given.length - 1]),
        hasCond: ci > -1,
        ed: ei > -1 ? (o[ei] || 'Normal') : 'Normal',
        lang: li > -1 ? (o[li] || 'English') : 'English',
        img: typeof vimg === 'string' ? vimg : null
      };
    });
    return { id: raw.id, handle: raw.handle, title: clean(raw.title), type: raw.product_type || '', image: typeof pimg === 'string' ? pimg : null, variants: variants };
  }
  // "Reverse-Holo Normal" -> "Reverse Holo", "PSA 10.0 Normal" -> "PSA 10", "Normal" -> "".
  function edLabel(ed) {
    return String(ed || '').replace(/\s*\bNormal$/i, '').replace(/-/g, ' ').replace(/(\d+)\.0\b/g, '$1').replace(/\s+/g, ' ').trim();
  }
  var LANG = dict({ 'English': '', 'Japanese': 'Japansk', 'German': 'Tysk', 'French': 'Fransk', 'Italian': 'Italiensk', 'Spanish': 'Spansk', 'Korean': 'Koreansk', 'Chinese': 'Kinesisk', 'Simplified Chinese': 'Kinesisk', 'Traditional Chinese': 'Kinesisk' });
  function langLabel(lang) { return lang in LANG ? LANG[lang] : String(lang || ''); }
  // Ét visningskort pr. udgave + sprog. Normal/engelsk først. Der vælges ALDRIG på tværs af udgaver.
  function tiles(product) {
    var by = Object.create(null), order = [];
    product.variants.forEach(function (v) {
      var key = v.ed + '|' + v.lang;
      if (!by[key]) { by[key] = { key: key, handle: product.handle, productId: product.id, title: product.title, ed: v.ed, lang: v.lang, edLabel: edLabel(v.ed), langLabel: langLabel(v.lang), image: null, variants: [] }; order.push(key); }
      by[key].variants.push(v);
      if (!by[key].image && v.img) by[key].image = v.img;
    });
    var out = order.map(function (k) {
      var t = by[k];
      if (!t.image) t.image = product.image;
      t.available = t.variants.some(function (v) { return v.available; });
      t.plain = !t.edLabel && !t.langLabel;
      return t;
    });
    out.sort(function (a, b) { return (a.plain === b.plain) ? 0 : (a.plain ? -1 : 1); });
    return out;
  }
  // Billigste tilgængelige variant pr. stand, bedste stand først (Mint og Near Mint er samme stand; ukendte sidst).
  function standSummary(tile) {
    var by = Object.create(null), keys = [];
    tile.variants.forEach(function (v) {
      if (!v.available) return;
      var k = known(v.cond), key = k ? 'r' + k.rank : 'u' + clean(v.cond).toLowerCase();
      if (!by[key]) { by[key] = v; keys.push(key); } else if (v.price < by[key].price) by[key] = v;
    });
    return keys.map(function (key) { return by[key]; }).sort(function (a, b) { return rank(a.cond) - rank(b.cond); });
  }
  // Det, et tryk på kortet lægger i: billigste tilgængelige inden for grænsen (ved prislighed den bedste stand).
  function pick(tile, limitKey) {
    var best = null;
    standSummary(tile).forEach(function (v) { if (within(v, limitKey) && (!best || v.price < best.price)) best = v; });
    return best;
  }
  function variantById(product, id) { for (var i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === String(id)) return product.variants[i]; return null; }

  /* ---------- binder ---------- */
  var CAP = 250, WARN_AT = 225;
  function makeItem(tile, v) {
    return { variantId: v.id, handle: tile.handle, productId: tile.productId, title: tile.title, cond: v.hasCond === false ? '' : v.cond, ed: tile.ed, lang: tile.lang, price: v.price, img: v.img || tile.image || null, qty: 1, max: v.qty, flag: '' };
  }
  function count(items) { return items.reduce(function (n, it) { return n + it.qty; }, 0); }
  function total(items) { return Math.round(items.reduce(function (t, it) { return t + it.price * it.qty; }, 0) * 100) / 100; }
  function indexOf(items, variantId) { for (var i = 0; i < items.length; i++) if (String(items[i].variantId) === String(variantId)) return i; return -1; }
  // Returnerer en NY liste. result: 'added' | 'inc' | 'max' (ikke flere på lager) | 'full' (loftet er nået).
  function add(items, item) {
    if (count(items) >= CAP) return { items: items, result: 'full', index: -1 };
    var i = indexOf(items, item.variantId), next = items.slice();
    if (i < 0) { next.push(item); return { items: next, result: 'added', index: next.length - 1 }; }
    // Det friske lagerantal på det nye tryk vinder over det gemte.
    var fresh = Math.floor(item.max), max = fresh >= 1 ? fresh : Math.max(next[i].max || 0, 1);
    if (next[i].qty >= max) return { items: items, result: 'max', index: i };
    next[i] = Object.assign({}, next[i], { qty: next[i].qty + 1, max: max });
    return { items: next, result: 'inc', index: i };
  }
  function setQty(items, variantId, qty) {
    var i = indexOf(items, variantId); if (i < 0) return items;
    var next = items.slice();
    qty = Math.floor(qty) || 0;
    if (qty <= 0) { next.splice(i, 1); return next; }
    var room = CAP - (count(items) - items[i].qty);
    next[i] = Object.assign({}, next[i], { qty: Math.max(1, Math.min(qty, Math.max(next[i].max || 1, 1), room)) });
    return next;
  }
  function describe(it) {
    var p = [it.cond && it.cond !== 'Default Title' ? it.cond : '', edLabel(it.ed), langLabel(it.lang), it.qty > 1 ? '×' + it.qty : ''];
    return p.filter(Boolean).join(' · ');
  }

  /* ---------- gem / hent ---------- */
  function serialize(items, now) { return JSON.stringify({ v: 2, t: now, items: items }); }
  // Handles kan indeholde ikke-latinske tegn; afvis kun det, der ikke kan være et handle (opslag sker med hasOwnProperty).
  var HANDLE = /^[^\s\/?#"'<>\\]+$/;
  function okItem(it) { return !!it && (typeof it.variantId === 'number' || typeof it.variantId === 'string') && typeof it.handle === 'string' && HANDLE.test(it.handle) && it.handle !== '__proto__' && typeof it.price === 'number' && isFinite(it.price); }
  function text(x) { return typeof x === 'string' || typeof x === 'number' ? clean(x) : ''; }
  function upTo4(x) { return Math.max(1, Math.min(MAX_QTY, Math.floor(x) || 1)); }
  // Ét gemt kort ind i listen: kun kendte felter i rette type, samme variant samles, højst MAX_QTY pr. variant og CAP i alt.
  function stash(out, o, ed, lang, qty, max) {
    var room = CAP - count(out), i = indexOf(out, o.variantId);
    if (room < 1) return;
    qty = Math.min(qty, room);
    if (i > -1) { out[i].qty = Math.min(MAX_QTY, out[i].qty + qty); out[i].max = Math.max(out[i].max, max, out[i].qty); return; }
    out.push({ variantId: o.variantId, handle: o.handle, productId: o.productId, title: text(o.title), cond: text(o.cond), ed: text(ed) || 'Normal', lang: text(lang) || 'English', price: o.price, img: typeof o.img === 'string' ? o.img : null, qty: qty, max: max, flag: text(o.flag) });
  }
  // v1 gemte én række pr. kort og udgave/sprog kun som "English / Played / Reverse-Holo Normal".
  function fromV1(arr) {
    var out = [];
    arr.forEach(function (o) {
      if (!okItem(o)) return;
      var parts = String(o.opts || '').split(' / ').filter(function (p) { return p && p !== o.cond; });
      var ed = parts.filter(function (p) { return /normal|holo|edition|psa|bgs|cgc|stamp/i.test(p); })[0] || 'Normal';
      var lang = parts.filter(function (p) { return p !== ed; })[0] || 'English';
      stash(out, o, ed, lang, 1, 1);
    });
    return out;
  }
  // Ødelagt eller ukendt indhold giver en tom binder, aldrig en fejl. t = 0 betyder "kontrollér straks"
  // (også når tidsstemplet er ugyldigt eller ligger efter now).
  function parse(v2str, v1str, now) {
    try {
      var d = JSON.parse(v2str);
      if (d && d.v === 2 && Array.isArray(d.items)) {
        var items = [];
        d.items.forEach(function (it) { if (okItem(it)) stash(items, it, it.ed, it.lang, upTo4(it.qty), upTo4(it.max)); });
        return { t: typeof d.t === 'number' && isFinite(d.t) && !(d.t > now) ? d.t : 0, items: items };
      }
    } catch (e) {}
    try { var a = JSON.parse(v1str); if (Array.isArray(a)) return { t: 0, items: fromV1(a) }; } catch (e2) {}
    return { t: 0, items: [] };
  }

  /* ---------- frisk kontrol før kurv ---------- */
  // fresh: { handle: normaliseret produkt | null (kunne ikke hentes) }. cart: { variantId: antal i kurven } | null (kunne ikke læses).
  // Returnerer opdaterede items + hvad der skal sendes, hvad der allerede ligger i kurven, hvad der er galt,
  // og baseline: netop den kurv, planen er regnet ud fra. Den skal gives videre til runCart.
  function reconcile(items, fresh, cart) {
    var out = { items: [], plan: [], already: [], problems: [], baseline: isMap(cart) ? cart : null };
    items.forEach(function (it0) {
      var it = Object.assign({}, it0, { flag: '' });
      out.items.push(it);
      // Uden kurv ved vi ikke, hvad der ligger der i forvejen: læg intet i.
      if (!out.baseline) { it.flag = 'Kunne ikke læse kurven'; out.problems.push({ item: it, code: 'tjek' }); return; }
      var p = isMap(fresh) && has(fresh, it.handle) ? fresh[it.handle] : null;
      if (!isMap(p) || !Array.isArray(p.variants)) { it.flag = 'Kunne ikke tjekke lager'; out.problems.push({ item: it, code: 'tjek' }); return; }
      var v = variantById(p, it.variantId);
      if (v) { it.ed = v.ed; it.lang = v.lang; }
      if (!v || !v.available || v.qty < 1) { it.flag = 'Solgt'; it.max = 0; out.problems.push({ item: it, code: 'solgt' }); return; }
      it.max = v.qty;
      if (v.qty < it.qty) { out.problems.push({ item: it, code: 'faerre', fra: it.qty }); it.qty = v.qty; }
      // Uden Condition-option (gradede kort) er der ingen stand at sammenligne; gemte v1-kort kan have 'Default Title' stående.
      var vc = v.hasCond === false ? '' : v.cond;
      var stand = v.hasCond !== false && clean(vc).toLowerCase() !== clean(it.cond).toLowerCase(), dyrere = v.price > it.price;
      if (stand) out.problems.push({ item: it, code: 'stand', fra: it.cond });
      if (dyrere) out.problems.push({ item: it, code: 'pris', fra: it.price });
      it.cond = vc; it.price = v.price;
      if (stand || dyrere) { it.flag = stand ? 'Stand ændret' : 'Pris ændret'; return; }
      var inCart = qtyIn(cart, it.variantId);
      var need = Math.min(Math.max(0, it.qty - inCart), Math.max(0, v.qty - inCart));
      if (need === 0) out.already.push(it); else out.plan.push({ variantId: it.variantId, quantity: need });
    });
    return out;
  }

  /* ---------- kurv-kørsel ---------- */
  // Målt i butikken 13.10.2026: én udsolgt vare i et kald = 422 og INTET lægges i; for stort antal = 422,
  // men det mulige antal ER lagt i. Derfor: ved 422 ser vi i kurven, hvad der faktisk kom i, og deler resten.
  // Alt andet end ok og 422 (429, 430, 403, 5xx, intet svar) er ikke varens skyld: se i kurven, men prøv ikke igen.
  // io.postAdd(lines) -> Promise<{ok, status, message}>; io.getCart() -> Promise<{variantId: antal}>; io.onProgress(done, total).
  // Afviser aldrig: hver linje i planen ender i added og/eller failed.
  var CHUNK = 25, MAX_POSTS = 120;
  var BUSY = 'Kurven svarer ikke. Prøv igen om lidt.', LATER = 'Prøv igen for de sidste kort.';
  function attempt(fn) { try { return Promise.resolve(fn()); } catch (e) { return Promise.reject(e); } }
  function runCart(plan, cart, io) {
    plan = Array.isArray(plan) ? plan : []; io = io || {};
    var state = dict(isMap(cart) ? cart : null), added = Object.create(null), failed = [], done = 0, posts = 0, strikes = 0;
    function note(id, n) { if (n > 0) added[id] = (added[id] || 0) + n; }
    function fail(lines, reason) { lines.forEach(function (l) { failed.push({ variantId: l.variantId, quantity: l.quantity, reason: reason }); }); }
    function send(lines) {
      if (!lines.length) return Promise.resolve();
      if (strikes >= 2) { fail(lines, BUSY); return Promise.resolve(); }
      if (posts >= MAX_POSTS) { fail(lines, LATER); return Promise.resolve(); }
      posts++;
      return attempt(function () { return io.postAdd(lines.map(function (l) { return { id: l.variantId, quantity: l.quantity }; })); })
        .then(function (r) { return isMap(r) ? r : {}; }, function () { return {}; })
        .then(function (res) {
          if (res.ok === true) { strikes = 0; lines.forEach(function (l) { note(l.variantId, l.quantity); state[l.variantId] = qtyIn(state, l.variantId) + l.quantity; }); return; }
          var busy = res.status !== 422;
          strikes = busy ? strikes + 1 : 0;
          return attempt(function () { return io.getCart(); }).then(function (after) { return isMap(after) ? after : Promise.reject(); }).then(function (after) {
            var rest = [];
            lines.forEach(function (l) {
              var landed = Math.max(0, Math.min(l.quantity, qtyIn(after, l.variantId) - qtyIn(state, l.variantId)));
              note(l.variantId, landed);
              if (landed < l.quantity) rest.push({ variantId: l.variantId, quantity: l.quantity - landed });
            });
            state = dict(after);
            if (!rest.length) return;
            if (busy) { fail(rest, BUSY); return; }
            // Ét kort tilbage: det er synderen.
            if (lines.length === 1) { fail(rest, typeof res.message === 'string' && res.message ? res.message : 'Kunne ikke lægges i kurven'); return; }
            if (rest.length === 1) return send(rest);
            var mid = Math.ceil(rest.length / 2);
            return send(rest.slice(0, mid)).then(function () { return send(rest.slice(mid)); });
          }, function () {
            // Kurven kan ikke læses: vi ved ikke, hvad der kom i. Meld alt som fejlet; næste tryk tjekker kurven først.
            fail(lines, BUSY);
          });
        });
    }
    var chain = Promise.resolve();
    for (var i = 0; i < plan.length; i += CHUNK) (function (part) {
      chain = chain.then(function () { return send(part); }).then(function () {
        done += part.length;
        if (io.onProgress) { try { io.onProgress(done, plan.length); } catch (e) {} }
      });
    })(plan.slice(i, i + CHUNK));
    // Id'et gives tilbage i samme type som i planen. Også efter en uventet fejl meldes det, der nåede i kurven.
    function result() {
      var out = [], seen = Object.create(null);
      plan.forEach(function (l) { var k = String(l && l.variantId); if (seen[k] || !added[k]) return; seen[k] = 1; out.push({ variantId: l.variantId, quantity: added[k] }); });
      return { added: out, failed: failed };
    }
    return chain.then(result, result);
  }
  // Efter kørslen: fjern det, der er i kurven (lagt i nu eller lå der allerede); behold resten med årsag.
  // Et kort, der blev sendt og ikke står i failed, er helt i mål, uanset hvor meget der lå i kurven i forvejen.
  function settle(items, result, already) {
    var addedBy = Object.create(null), failBy = Object.create(null), alreadyBy = Object.create(null);
    result.added.forEach(function (a) { addedBy[String(a.variantId)] = a.quantity; });
    result.failed.forEach(function (f) { failBy[String(f.variantId)] = f; });
    (already || []).forEach(function (it) { alreadyBy[String(it.variantId)] = 1; });
    var left = [], inCart = 0;
    items.forEach(function (it) {
      var id = String(it.variantId), f = failBy[id];
      if (alreadyBy[id]) return;
      inCart += addedBy[id] || 0;
      // Antallet er målet i kurven (reconcile lægger kun forskellen i), så det bevares ved fejl: næste tryk henter resten.
      if (f) { left.push(Object.assign({}, it, { flag: f.reason })); return; }
      // Med flag (solgt, pris/stand ændret, kunne ikke tjekkes) blev kortet aldrig sendt.
      if (it.flag || !(id in addedBy)) left.push(it);
    });
    return { items: left, added: inCart };
  }

  /* ---------- sortering og filtre i den viste liste ---------- */
  // Sjældenheden står i titlens sidste parentes efter sættet: "Moltres - 30th Celebration (Illustration Rare) [30C-130]".
  // Navnets egne parenteser ("Luffy (OP01-024) (V.1) - …") tæller ikke. '' uden (fx gradede kort).
  // Bindestregen må have alle slags mellemrum (også hårde) og være en tankestreg.
  function rarityOf(title) {
    var t = clean(title), d = t.match(/\s[-\u2013\u2014]\s/), m = d ? t.slice(d.index + d[0].length).match(/\(([^()]*)\)[^()]*$/) : null;
    return m ? clean(m[1]) : '';
  }
  var ED_GROUPS = [{ key: 'normal', label: 'Normal' }, { key: 'rh', label: 'Reverse Holo' }, { key: 'andre', label: 'Andre udgaver' }];
  function edGroup(ed) { var l = edLabel(ed); return !l ? 'normal' : /^reverse holo$/i.test(l) ? 'rh' : 'andre'; }
  // Master set (Mine samlinger): en lomme har udgaven 'normal' eller 'rh'.
  // tileUdgave(tile.key) -> { udgave: 'normal'|'rh'|'andre', engelsk } ud fra nøglen "udgave|sprog" (data-tile på kortet).
  function tileUdgave(key) {
    var k = String(key == null ? '' : key), i = k.lastIndexOf('|');
    var ed = i > -1 ? k.slice(0, i) : k, lang = i > -1 ? k.slice(i + 1) : 'English';
    return { udgave: edGroup(ed || 'Normal'), engelsk: !langLabel(lang || 'English') };
  }
  // Det kort (tile), der købes for en lomme: 'normal' -> den almindelige udgave (Normal, engelsk), 'rh' -> Reverse Holo på engelsk.
  // null, når produktet ikke har den udgave. Andre udgaver (Stamped, 1st Edition osv.) vælges aldrig.
  function udgaveTile(product, udgave) {
    var ts = tiles(product);
    if (udgave === 'rh') {
      for (var i = 0; i < ts.length; i++) if (edGroup(ts[i].ed) === 'rh' && !ts[i].langLabel) return ts[i];
      return null;
    }
    return ts[0] && ts[0].plain ? ts[0] : null;
  }
  // Kortnummeret i titlens sidste [..]. Første led er sættets kode og springes over, når der er flere led:
  // "30C-130" -> 130, "CRZ-GG17" -> GG 17, "30C-BS 4" -> BS 4, "SV-P 001" -> P 1, "001/165" -> 1.
  // Et sprog-led på to bogstaver i midten springes også over: "OP01-JP-078" -> 78, "SVP-EN-001" -> 1.
  // Uden [..]: "#TG27" (gradede kort) eller "4/102". Svar { pre, n, suf, label } eller null, når der intet nummer er.
  // label er til mærket på kortet: uden foranstillede nuller ("#30", ikke "#030"); sorteringen bruger n.
  function cardCode(title) {
    var t = clean(title), b = t.match(/\[([^\[\]]*)\][^\[\]]*$/), raw = '';
    if (b) {
      var segs = clean(b[1]).split('-');
      if (segs.length > 2 && /^\s*[A-Za-z]{2}\s*$/.test(segs[1])) segs.splice(1, 1);
      var parts = segs.join('-').split(/[-\s]+/).filter(Boolean);
      raw = (parts.length > 1 ? parts.slice(1) : parts).join(' ');
    } else {
      var h = t.match(/#\s*([A-Za-z]*\d+[A-Za-z]?)/) || t.match(/(\d+\s*\/\s*\d+)/);
      raw = h ? h[1] : '';
    }
    var m = raw.match(/^(.*?)(\d+)(?:\s*\/\s*\d+)?([A-Za-z]*)$/);
    return m ? { pre: clean(m[1]).replace(/\s+/g, ' ').toUpperCase(), n: parseInt(m[2], 10), suf: m[3].toLowerCase(), label: raw.replace(/(^|\D)0+(?=\d)/g, '$1') } : null;
  }
  var SORT_LABELS = dict({ rel: 'Relevans', nr: 'Kortnummer', 'pris-op': 'Pris lav til høj', 'pris-ned': 'Pris høj til lav', navn: 'Navn A-Å' });
  // Et sæt (numbered) står allerede i nummerorden og har ingen "relevans". Andre lister starter i den rækkefølge, de kom i.
  function sorts(numbered) {
    return (numbered ? ['nr'] : ['rel', 'nr']).concat(['pris-op', 'pris-ned', 'navn']).map(function (k) { return { key: k, label: SORT_LABELS[k] }; });
  }
  // Den ønskede sortering, når listen har den; ellers listens standard.
  function sortFor(want, numbered) { var ks = sorts(numbered).map(function (s) { return s.key; }); return ks.indexOf(want) > -1 ? want : ks[0]; }
  // De sjældenheder (alfabetisk) og udgave-grupper (fast rækkefølge), listen faktisk har.
  function facets(tiles) {
    var rar = Object.create(null), rs = [], eds = Object.create(null);
    tiles.forEach(function (t) { var r = rarityOf(t.title); if (r && !rar[r]) { rar[r] = 1; rs.push(r); } eds[edGroup(t.ed)] = 1; });
    return { rarities: rs.sort(function (a, b) { return a.localeCompare(b, 'da'); }), eds: ED_GROUPS.map(function (g) { return g.key; }).filter(function (k) { return eds[k]; }) };
  }
  function byCode(a, b) {
    if (!a || !b) return a ? -1 : b ? 1 : 0; // uden nummer sidst
    if (a.pre !== b.pre) return !a.pre ? -1 : !b.pre ? 1 : a.pre < b.pre ? -1 : 1; // hovedsættet før TG, GG, BS …
    return a.n - b.n || (a.suf < b.suf ? -1 : a.suf > b.suf ? 1 : 0);
  }
  // Ny liste med de kort, der passer til filtrene (opts.rarity, opts.ed: '' = alle), sorteret efter opts.sort.
  // priceOf(tile) giver prisen på det, kortet viser som valgt (null = ingen pris: sidst i begge retninger).
  // Ved lighed bevares listens egen rækkefølge, så et korts udgaver bliver stående sammen.
  function arrange(tiles, opts, priceOf) {
    opts = opts || {};
    var s = opts.sort, rows = [];
    tiles.forEach(function (t, i) {
      if (opts.rarity && rarityOf(t.title) !== opts.rarity) return;
      if (opts.ed && edGroup(t.ed) !== opts.ed) return;
      var p = (s === 'pris-op' || s === 'pris-ned') && priceOf ? priceOf(t) : null;
      rows.push({ t: t, i: i, p: typeof p === 'number' && isFinite(p) ? p : null, c: s === 'nr' ? cardCode(t.title) : null });
    });
    function cmp(a, b) {
      if (s === 'pris-op' || s === 'pris-ned') {
        if (a.p === null || b.p === null) return a.p === null ? (b.p === null ? 0 : 1) : -1;
        return s === 'pris-op' ? a.p - b.p : b.p - a.p;
      }
      if (s === 'navn') return a.t.title.localeCompare(b.t.title, 'da');
      if (s === 'nr') return byCode(a.c, b.c) || a.t.title.localeCompare(b.t.title, 'da');
      return 0;
    }
    rows.sort(function (a, b) { return cmp(a, b) || a.i - b.i; });
    return rows.map(function (r) { return r.t; });
  }

  /* ---------- læg alle viste i binderen ---------- */
  // rows = [{ tile, v }] i den viste rækkefølge; v er det, kortet viser som valgt (null = intet valg).
  // Med kommer kort, hvis valg er på lager, og hvis udgave (handle, udgave, sprog) ikke allerede ligger i binderen. Samme udgave én gang.
  function bulkRows(rows, items) {
    var seen = Object.create(null), out = [];
    (items || []).forEach(function (it) { seen[it.handle + '|' + it.ed + '|' + it.lang] = 1; });
    (rows || []).forEach(function (r) {
      var t = r && r.tile, v = r && r.v, k = t ? t.handle + '|' + t.ed + '|' + t.lang : '';
      if (!t || !v || !v.available || !(v.qty >= 1) || seen[k]) return;
      seen[k] = 1;
      out.push({ tile: t, v: v });
    });
    return out;
  }
  // Lægger hvert kort i med antal 1, i rækkefølgen, til loftet er nået. Svar: { items (ny liste), added }.
  function addRows(items, rows) {
    var next = items, added = 0;
    for (var i = 0; i < rows.length; i++) {
      var r = add(next, makeItem(rows[i].tile, rows[i].v));
      if (r.result === 'full') break;
      if (r.result === 'added' || r.result === 'inc') { next = r.items; added++; }
    }
    return { items: next, added: added };
  }

  /* ---------- broen til Mine samlinger (mtw-samling-binder.js) ---------- */
  // Nøgler som i match_produkter: sæt i lowercase, nr i lowercase uden foranstillede nuller.
  function sbNormSet(s) { return String(s || '').toLowerCase().trim(); }
  function sbNormNo(n) { return String(n || '').toLowerCase().trim().replace(/^0+(?=\d)/, ''); }
  // Titel-format: "Name - Set Name (Rarity) [NUMBER]", evt. med sæt-kode-præfiks i bracket ("POR-115"). null uden sæt eller nummer.
  function sbParseTitle(t) {
    t = String(t || '').replace(/\s+/g, ' ').trim();
    var bm = t.match(/\[([^\]]+)\]\s*$/);
    if (!bm) return null;
    var rawNo = bm[1].trim();
    if (!rawNo) return null;
    var head = t.slice(0, t.length - bm[0].length);
    var pi = head.lastIndexOf('(');
    if (pi > -1) head = head.slice(0, pi);
    var di = head.lastIndexOf(' - ');
    if (di < 0) return null;
    var set = head.slice(di + 3).trim();
    if (!set) return null;
    var stripped = rawNo.replace(/^[A-Za-z]+-\s*/, '');
    var numbers = [stripped];
    if (sbNormNo(rawNo) !== sbNormNo(stripped)) numbers.push(rawNo);
    return { set: set, numbers: numbers };
  }
  // Kortets opslagsnøgler "sæt|nr" (uden udgave). null, når titlen ikke kan læses.
  function sbKeys(title) {
    var p = sbParseTitle(title);
    if (!p) return null;
    var keys = [];
    for (var i = 0; i < p.numbers.length; i++) {
      var k = sbNormSet(p.set) + '|' + sbNormNo(p.numbers[i]);
      if (keys.indexOf(k) < 0) keys.push(k);
    }
    return keys;
  }
  // Kortets lommer i svaret fra match_produkter: { normal, rh } med { e, key, udgave }, eller null.
  // Nyt svar har "sæt|nr|normal" og "sæt|nr|rh"; ældre svar kun "sæt|nr" (= kort-lommen).
  function sbLommer(map, keys) {
    if (!keys || !isMap(map)) return null;
    var normal = null, rh = null;
    function at(k) { return has(map, k) && isMap(map[k]) ? map[k] : null; }
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i], eR = at(k + '|rh'), eN = at(k + '|normal'), e = at(k);
      if (!rh && eR) rh = { e: eR, key: k + '|rh', udgave: 'rh' };
      if (!normal && eN) normal = { e: eN, key: k + '|normal', udgave: 'normal' };
      if (e) {
        if (e.udgave === 'rh') { if (!rh) rh = { e: e, key: k + '|rh', udgave: 'rh' }; }
        else if (!normal) normal = { e: e, key: k, udgave: 'normal' };
      }
    }
    return (normal || rh) ? { normal: normal, rh: rh } : null;
  }
  // Er binderen et master set? ctx = { masterBinders?: [id], binders?: [{ id, master? }] } fra match_produkter.
  // true/false, eller null, når svaret ikke siger det (ældre backend).
  function sbMasterBinder(id, ctx) {
    ctx = ctx || {};
    var mb = ctx.masterBinders, bs = Array.isArray(ctx.binders) ? ctx.binders : [], i;
    if (Array.isArray(mb)) { for (i = 0; i < mb.length; i++) if (String(mb[i]) === String(id)) return true; return false; }
    for (i = 0; i < bs.length; i++) if (bs[i] && String(bs[i].id) === String(id) && typeof bs[i].master === 'boolean') return bs[i].master;
    return null;
  }
  // Strengt (kun ren Normal eller Reverse Holo på engelsk opfylder lommen): altid for RH-lommer, og for kort-lommer i master sets.
  // Gælder pr. lomme, så en almindelig samling med samme kort opfører sig som før. Siger svaret ikke, om binderen er et master set
  // (ældre backend), gælder den gamle regel: strengt, når kortet har en RH-lomme.
  function sbStreng(hit, l, ctx) {
    if (!hit) return false;
    if (hit.udgave === 'rh') return true;
    var m = hit.e && typeof hit.e.master === 'boolean' ? hit.e.master : sbMasterBinder(hit.e && hit.e.binder_id, ctx);
    return m === null ? !!(l && l.rh) : m;
  }
  // Lommen, der hører til ét kort (én udgave). u = tileUdgave(...) eller null (ukendt udgave).
  // RH-lommen får kun Reverse Holo på engelsk. En streng kort-lomme får kun Normal på engelsk; en almindelig kort-lomme gælder
  // alle kortets udgaver (som før).
  function sbEntry(l, u, ctx) {
    if (!l) return null;
    if (l.rh && u && u.engelsk && u.udgave === 'rh') return l.rh;
    if (!l.normal) return null;
    if (!sbStreng(l.normal, l, ctx)) return l.normal;
    return u && u.engelsk && u.udgave === 'normal' ? l.normal : null;
  }
  // Mangel-baren. rows = [{ handle, l, tiles: [{ udgave, engelsk, state: 'ok'|'udenfor'|'udsolgt', hidden, price }] }] i den viste
  // rækkefølge (tiles[0] er kortets første viste udgave). Svar { groups: { binderId: g }, order: [binderId] } med
  // g = { id, navn, items: [{ entry, key, handle, price, udgave }], udsolgt, udenfor, anden, master }.
  //   Streng lomme: kun den viste udgave, lommen kræver (engelsk), tæller. Er den ikke vist (skjult af udgave-filteret
  //     eller findes ikke), springes lommen over; 'udsolgt' tæller kun, når den er vist og udsolgt.
  //   Almindelig lomme (som før): den almindelige udgave købes; 'anden' = kun en anden udgave kan lægges i.
  // Samme lomme under to handles tælles én gang. g.master følger binderen; ved en ældre backend: strenge lommer i gruppen.
  function sbBarGroups(rows, ctx) {
    var groups = Object.create(null), order = [];
    (rows || []).forEach(function (r) {
      var l = r && r.l, tiles = (r && r.tiles) || [];
      if (!l || !tiles.length) return;
      [l.normal, l.rh].forEach(function (hit) {
        if (!hit || !hit.e || hit.e.har) return;
        var streng = sbStreng(hit, l, ctx);
        if (!streng && tiles[0].hidden) return;
        var gid = String(hit.e.binder_id), g = groups[gid];
        if (!g) {
          var bm = sbMasterBinder(hit.e.binder_id, ctx);
          g = groups[gid] = { id: hit.e.binder_id, navn: hit.e.binder || 'din binder', items: [], udsolgt: 0, udenfor: 0, anden: 0, master: bm === true, kendt: bm !== null, seen: Object.create(null) };
          order.push(gid);
        }
        if (g.seen[hit.key]) return;
        var j;
        if (streng) {
          var maal = null;
          for (j = 0; j < tiles.length && !maal; j++) if (tiles[j].udgave === hit.udgave && tiles[j].engelsk && !tiles[j].hidden) maal = tiles[j];
          if (!maal) return;
          g.seen[hit.key] = 1;
          if (!g.kendt) g.master = true;
          if (maal.state === 'ok') g.items.push({ entry: hit.e, key: hit.key, handle: r.handle, price: maal.price || 0, udgave: hit.udgave });
          else if (maal.state === 'udenfor') g.udenfor++;
          else g.udsolgt++;
          return;
        }
        g.seen[hit.key] = 1;
        var plain = null, andenOk = false, paaLager = false;
        for (j = 0; j < tiles.length; j++) {
          var t = tiles[j];
          if (t.state !== 'udsolgt') paaLager = true;
          if (t.udgave === 'normal' && t.engelsk) { if (!plain) plain = t; }
          else if (t.state === 'ok') andenOk = true;
        }
        if (plain && plain.state === 'ok') g.items.push({ entry: hit.e, key: hit.key, handle: r.handle, price: plain.price || 0, udgave: 'normal' });
        else if (andenOk) g.anden++;
        else if (paaLager) g.udenfor++;
        else g.udsolgt++;
      });
    });
    order.forEach(function (gid) { delete groups[gid].seen; delete groups[gid].kendt; });
    return { groups: groups, order: order };
  }
  // Efter MTWC.checkoutHandles: de lommer (entry), der kom i kurven. items = [{ entry, handle, udgave }].
  // RH-kort står som 'rh:' + handle i outside/unchecked/changed; i left bærer hvert kort sin egen ed.
  // Uden RH-køb (harRh falsk) afgør handle alene, som før.
  function sbLagt(items, rep, harRh) {
    rep = rep || {};
    var left = rep.left || [], ud = rep.outside || [], ut = rep.unchecked || [], ae = rep.changed || [], out = [];
    (items || []).forEach(function (it) {
      var rh = it.udgave === 'rh', id = rh ? 'rh:' + it.handle : it.handle;
      var tilbage = left.some(function (x) { return x && x.handle === it.handle && (!harRh || edGroup(x.ed) === (rh ? 'rh' : 'normal')); }) ||
        ud.indexOf(id) > -1 || ut.indexOf(id) > -1 || ae.indexOf(id) > -1;
      if (!tilbage) out.push(it.entry);
    });
    return out;
  }

  /* ---------- direkte link ---------- */
  // Adressens parametre (med eller uden "?") -> det, værktøjet skal åbne med. null = ikke en direkte åbning:
  // hverken saet, kol, q, aabn=1 eller mangler=1 er til stede. Rækkefølge ved flere: saet, kol, q, ellers forsiden.
  // Et ugyldigt handle og en tom eller ulæselig søgetekst falder videre til næste regel; linket åbner stadig værktøjet.
  // Står en parameter to gange, gælder den første. Kaster aldrig.
  var LINK_HANDLE = /^[a-z0-9][a-z0-9_-]*$/, Q_MAX = 80;
  function deeplink(search) {
    var p = Object.create(null);
    (typeof search === 'string' ? search : '').replace(/^\?/, '').split('&').forEach(function (part) {
      var i = part.indexOf('='), k = i < 0 ? part : part.slice(0, i);
      if (!(k in p)) p[k] = i < 0 ? '' : part.slice(i + 1);
    });
    var mangler = p.mangler === '1';
    if (!('saet' in p || 'kol' in p || 'q' in p || p.aabn === '1' || mangler)) return null;
    function out(mode, handle, q) { return { mode: mode, handle: handle, q: q, mangler: mangler }; }
    if ('saet' in p && LINK_HANDLE.test(p.saet)) return out('saet', p.saet, '');
    if ('kol' in p && LINK_HANDLE.test(p.kol)) return out('kol', p.kol, '');
    var q = '';
    // Efter snittet kan der stå et halvt tegn (første halvdel af et surrogatpar): det fjernes, ellers kan teksten ikke sendes i en adresse.
    if ('q' in p) { try { q = clean(clean(decodeURIComponent(p.q.replace(/\+/g, ' '))).slice(0, Q_MAX).replace(/[\uD800-\uDBFF]$/, '')); } catch (e) {} }
    return q ? out('q', '', q) : out('forside', '', '');
  }

  return {
    clean: clean, STANDS: STANDS, LIMITS: LIMITS, rank: rank, within: within, abbr: abbr, limitOf: limitOf,
    MAX_QTY: MAX_QTY, normalize: normalize, edLabel: edLabel, langLabel: langLabel, tiles: tiles, standSummary: standSummary, pick: pick, variantById: variantById,
    CAP: CAP, WARN_AT: WARN_AT, makeItem: makeItem, count: count, total: total, indexOf: indexOf, add: add, setQty: setQty, describe: describe,
    serialize: serialize, parse: parse, reconcile: reconcile, CHUNK: CHUNK, runCart: runCart, settle: settle,
    rarityOf: rarityOf, ED_GROUPS: ED_GROUPS, edGroup: edGroup, tileUdgave: tileUdgave, udgaveTile: udgaveTile, cardCode: cardCode, sorts: sorts, sortFor: sortFor, facets: facets, arrange: arrange,
    bulkRows: bulkRows, addRows: addRows,
    sbNormSet: sbNormSet, sbNormNo: sbNormNo, sbParseTitle: sbParseTitle, sbKeys: sbKeys, sbLommer: sbLommer, sbMasterBinder: sbMasterBinder,
    sbStreng: sbStreng, sbEntry: sbEntry, sbBarGroups: sbBarGroups, sbLagt: sbLagt,
    deeplink: deeplink
  };
});
